export const Solid = Object.freeze({
	THREE_PERSONS: 's-3-persons',
	ACTIVITY: 's-activity',
	AI_STARS: 's-ai-stars',
	ALERT_ACCENT: 's-alert-accent',
	ALERT: 's-alert',
	APPS: 's-apps',
	ATTACH: 's-attach',
	BOARD: 's-board',
	BOOKMARK: 's-bookmark',
	BOTTLENECK: 's-bottleneck',
	BROWSER: 's-browser',
	BUG: 's-bug',
	BUSINESS_PROCESS: 's-business-process',
	CALENDAR_WITH_SLOTS: 's-calendar-with-slots',
	CAMERA: 's-camera',
	CHATS: 's-chats',
	CHECK: 's-check',
	CIRCLE_CHECK: 's-circle-check',
	CLOCK: 's-clock',
	CLOUD_SYNC: 's-cloud-sync',
	CLOUD: 's-cloud',
	COLLAB: 's-collab',
	COLLABORATION: 's-collaboration',
	COMPANY: 's-company',
	COMPLETE_TASK_LIST: 's-complete-task-list',
	CONTACT_CENTER: 's-contact-center',
	COPILOT: 's-copilot',
	CRM_LETTERS: 's-crm-letters',
	CRM: 's-crm',
	CROWN: 's-crown',
	CURSOR_CLICK: 's-cursor-click',
	DATABASE: 's-database',
	DEPARTMENT: 's-department',
	DEVELOPER_RESOURCES: 's-developer-resources',
	DOCUMENT_SIGN: 's-document-sign',
	EARTH: 's-earth',
	EMPLOYEE: 's-employee',
	ENTERPRISE: 's-enterprise',
	FAVORITE: 's-favorite',
	FILE: 's-file',
	FIRE: 's-fire',
	FOLDER: 's-folder',
	FULL_BATTERY: 's-full-battery',
	GRADUATION_CAP: 's-graduation-cap',
	GRAPHS_DIAGRAM: 's-graphs-diagram',
	GROUP: 's-group',
	HANDSHAKE: 's-handshake',
	HEART: 's-heart',
	HOME: 's-home',
	KANBAN: 's-kanban',
	KEY: 's-key',
	KNOWLEDGE_BASE: 's-knowledge-base',
	LEAD: 's-lead',
	LIKE: 's-like',
	LOCATION: 's-location',
	MAGIC_WAND: 's-magic-wand',
	MAIL: 's-mail',
	MAIN_TOOL: 's-main-tool',
	MARKET: 's-market',
	MARKETING: 's-marketing',
	MESSAGE: 's-message',
	MICROPHONE_ON: 's-microphone-on',
	MOON: 's-moon',
	NEUTRAL: 's-neutral',
	NEWSFEED: 's-newsfeed',
	NOTE: 's-note',
	NOTIFICATION: 's-notification',
	OBSERVER: 's-observer',
	ONLINE_BOOKING: 's-online-booking',
	OPEN_CHANNELS: 's-open-channels',
	PAUSE: 's-pause',
	PAYMENT_TERMINAL: 's-payment-terminal',
	PERSON: 's-person',
	PHONE_ADD: 's-phone-add',
	PHONE_BROKEN: 's-phone-broken',
	PHONE_IN: 's-phone-in',
	PHONE_OUT: 's-phone-out',
	PHONE_UP: 's-phone-up',
	PIN: 's-pin',
	PLAY: 's-play',
	PLUS: 's-plus',
	PROCESSES: 's-processes',
	PRODUCT_WRAPPED: 's-product-wrapped',
	PRODUCT: 's-product',
	RECORD_VIDEO: 's-record-video',
	REFRESH: 's-refresh',
	REPEAT: 's-repeat',
	ROBOT: 's-robot',
	ROCKET: 's-rocket',
	ROLES_LIBRARY: 's-roles-library',
	SAD: 's-sad',
	SCREEN: 's-screen',
	SERVICE: 's-service',
	SETTINGS: 's-settings',
	SHIELD_CHECKED: 's-shield-checked',
	SHIELD: 's-shield',
	SHOPPING_CART: 's-shopping-cart',
	SIGN: 's-sign',
	SMART_PROCESS: 's-smart-process',
	SMILE: 's-smile',
	SOUND_OFF: 's-sound-off',
	SOUND_ON: 's-sound-on',
	STAGE: 's-stage',
	STOCK: 's-stock',
	STOP_HAND: 's-stop-hand',
	STORAGE: 's-storage',
	STRESS: 's-stress',
	SUBSCRIPTION: 's-subscription',
	TASK_LIST: 's-task-list',
	TASK: 's-task',
	TRASHCAN: 's-trashcan',
	VERIFICATION: 's-verification',
	WALLET: 's-wallet',
	WINDOW_FLAG: 's-window-flag',
	CROWN_1: 's-crown-1',
} as const);
